import {fragments} from '@/gql';
const {gql} = require('graphql-tag');
export default gql`
  mutation updateCallsheet($id: ID!, $input: CallsheetUpdate!) {
    updateCallsheet(id: $id, input: $input) {
      ...callsheetDetail
    }
  }
  ${fragments.callsheetDetail}
  ${fragments.artworkDetails}
  ${fragments.artworkArtifact}
`;
